import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth, useIsPlatformAdmin } from '../../../hooks/useAuth'
import { useBreadcrumbs } from '../../../hooks/useBreadcrumbs'
import { PageHeader } from '../../../components/shared/PageHeader'
import { SECTION_ICONS } from '../../../lib/section-icons'
import { BillingSimulator } from '../../../components/admin/BillingSimulator'

export const Route = createFileRoute('/admin/billing/simulator')({
  component: RouteComponent,
})

// What a plan would cost over a usage curve, with no writes (spec
// 2026-10-09-02). Platform admins only.
function RouteComponent() {
  const { t } = useTranslation('admin')
  const { loading, orgCode } = useAuth()
  const isPlatformAdmin = useIsPlatformAdmin()
  const navigate = useNavigate({ from: '/admin/billing/simulator' })

  useEffect(() => {
    if (!loading && !isPlatformAdmin) {
      navigate({ to: '/', replace: true })
    }
  }, [loading, isPlatformAdmin, navigate])

  const breadcrumbOrg = orgCode || 'demo'
  useBreadcrumbs([
    { title: t('common:nav.home'), path: `/${breadcrumbOrg}` },
    { title: t('settings:page.title'), path: `/${breadcrumbOrg}/settings` },
    { title: t('billing.title'), path: '/admin/billing' },
    { title: t('billing.simulator.title') },
  ])

  if (loading || !isPlatformAdmin) {
    return null
  }

  return (
    <div className="space-y-6" data-testid="admin-billing-simulator-page">
      <PageHeader icon={SECTION_ICONS.adminBilling} title={t('billing.simulator.title')} description={t('billing.simulator.subtitle')} />
      <BillingSimulator />
    </div>
  )
}
